export default __webpack_public_path__ + "static/media/my-parts.f793d758.png";